import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DesignSystemModule } from '@inyova/design-system';
import { InyovaSharedModule } from '@inyova/inyova-shared';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import * as fromComponents from './components';
import { WithdrawalService } from './services/withdrawal.service';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, IonicModule, DesignSystemModule, InyovaSharedModule],
  declarations: [...fromComponents.components],
  exports: [...fromComponents.components],
  providers: [WithdrawalService]
})
export class WithdrawalModule {}
